import apiService, { GalleryConfig } from './api-service'
import { encodeArray } from 'util/turnto-utils'

export const GALLERY_FETCH_LIMIT = 25

export function getMediaList(
  skus: Array<string>,
  tags: Array<string>,
  offset: number,
  galleryConfig: GalleryConfig
) {
  return apiService.mediaList({
    skus: encodeArray(skus),
    offset,
    limit: GALLERY_FETCH_LIMIT,
    sort: galleryConfig.sortOrder,
    tags: encodeArray(tags),
    minCharCount: galleryConfig.minTextContentCharacterCount,
    minWordCount: galleryConfig.minTextContentWordCount,
    includeProductSiblings: galleryConfig.includeProductSiblings,
    includeSyndicated: galleryConfig.includeSyndicated
  })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/services/media-service.ts